import { render } from "./SegmentControls.vue?vue&type=template&id=31a87ab3"
import script from "./SegmentControls.vue?vue&type=script&lang=js"
export * from "./SegmentControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__